import React from 'react';
import Footer from '../Shared/Footer/Footer';
import NavBar2 from '../Shared/NavBar2/NavBar2';

const OurProcess = () => {
    return (
        <>
            <NavBar2 />
            <div className="wwd margin">
                <div className="about1">
                    <h1 className="text-dark mt-5">Our Process</h1>
                    <p>Etiam convallis, felis quis dapibus dictum, libero mauris luctus <br /> nunc, non fringilla purus ligula non justo. Non fringilla purus.</p>
                </div>
            </div>
            {/* part -1 */}
            <div className="container mb-5">
                <div className="row">
                    <div className="col-lg-4">
                        <img src="https://i.ibb.co/qDPSgdc/our-process-img-1.jpg" alt="" className="img-fluid" />
                    </div>
                    <div className="col-lg-4 text-center mt-5">
                        <img src="https://i.ibb.co/SxxPmYx/2.png" alt="" />
                        <h5>Smooth Bite</h5>
                        <small>Quisque vel eros sit amet nullapel lentes cursus. Morbi blandit luctus lorem set.</small>
                    </div>
                    <div className="col-lg-4 text-center mt-5">
                        <img src="https://i.ibb.co/nrqkyrX/5.png" alt="" />
                        <h5>Smooth Bite</h5>
                        <small>Quisque vel eros sit amet nullapel lentes cursus. Morbi blandit luctus lorem set.</small>
                    </div>
                </div>
            </div>
            {/* part 2 */}
            <div className="container-fluid part2_img">
                <div className="row">
                    <div className="col-lg-6 part2_css " >
                       <div className="part2_width container">
                       <h3>Our Great Story</h3>
                        <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam blandit hendrerit faucibus. Suspendisse hendrerit turpis dui, eget ultricies erat consequat ut. Sed ac velit iaculis, condimentum neque eu, maximus urna. Maecenas vitae nunc sit amet risus aliquet.
                        </small>
                       </div>
                    </div>
                    <div className="col-lg-6 img-fluid ">
                        <img width="80%" className="m-5 pt-5" 
                        src="https://i.ibb.co/fXgW1n5/our-process-img-2.jpg" alt="" />
                    </div>

                </div>

            </div>
            {/* part 3 */}




            <Footer />


        </>
    );
};

export default OurProcess;